import ApplicationService from '../../services/applicationService';
// eslint-disable-next-line max-len
import type { ConfirmProps } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress/Modal/Modal.types';
import messages from './messages';
import useIntl from '../../hooks/useIntl';
import {
  getPrimaryPhoneNumber,
  getPrimaryEmailAddress,
} from '../../utils/contact-helpers';

export function convertToApplicant(
  data,
  organizationId,
  additionalPhoneAndEmailFieldsForLeadProfile = false,
) {
  const applicationService = new ApplicationService();

  // If the flag is false, clean up the payload to remove phones and emails arrays
  if (!additionalPhoneAndEmailFieldsForLeadProfile) {
    const cleanedData = {
      ...data,
      adults:
        data.adults?.map((adult) => {
          const { phones, emails, ...cleanedAdult } = adult;
          return cleanedAdult;
        }) || [],
    };

    return applicationService.save(cleanedData, organizationId);
  }

  // If the flag is true, include phones and emails arrays and update primary contact info
  const dataWithUpdatedPrimaryContacts = {
    ...data,
    adults:
      data.adults?.map((adult) => {
        const primaryPhone = getPrimaryPhoneNumber(adult.phones, adult.phone);
        const primaryEmail = getPrimaryEmailAddress(adult.emails, adult.email);

        return {
          ...adult,
          phone: primaryPhone,
          email: primaryEmail,
          phones: adult.phones || [],
          emails: adult.emails || [],
        };
      }) || [],
  };

  return applicationService.save(
    dataWithUpdatedPrimaryContacts,
    organizationId,
  );
}

export function useModalConfirmProps(
  open: boolean,
  onClick: (confirm: boolean) => void,
): ConfirmProps {
  const intl = useIntl();
  const actionsProps = [
    { children: 'No', onClick: () => onClick(false) },
    { children: 'Yes', onClick: () => onClick(true) },
  ];

  return {
    open,
    actionsProps,
    title: intl.formatMessage(messages.convertConfirmation),
  };
}
